var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("or-teleport", [
    _c("div", { attrs: { "data-component": "base-tabs-mobile-popup" } }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "or-button",
            {
              attrs: {
                "is-text": "",
                "data-button": "close",
                color: "neutral-6",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close-click")
                },
              },
            },
            [_c("or-icon", { attrs: { icon: "close" } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "header-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("hitl.modules.settings.session-views.title")) +
                "\n      "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main" },
        _vm._l(_vm.menuItems, function (ref) {
          var value = ref.value
          var label = ref.label
          return _c(
            "a",
            {
              key: value,
              class: { active: _vm.activeItemId === value },
              attrs: { "data-item": value },
              on: {
                click: function ($event) {
                  return _vm.$emit("item-click", value)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(label) + "\n      ")]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }